import React from 'react';
import {
  FormControl,
  FormLabel,
  Select,
  Box,
  Flex,
  useTheme,
} from '@chakra-ui/react';

interface AleaDropdownProps {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  isRequired?: boolean;
}

const AleaDropdown: React.FC<AleaDropdownProps> = ({
  label,
  value,
  options,
  onChange,
  error,
  placeholder,
  isRequired,
}) => {
  const theme = useTheme();
  const formLabelStyles = {
    fontWeight: isRequired ? 500 : 300,
    marginBottom: '3px',
    color: 'alea.500',
    paddingLeft: '16px',
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <FormControl isInvalid={!!error}>
      <FormLabel sx={formLabelStyles}>{label}</FormLabel>
      <Flex alignItems="center">
        <Select
          value={value}
          onChange={handleChange}
          borderRadius="20px"
          borderColor="#DCDCDC"
          h="50px"
          color="black"
          _hover={{ borderColor: 'gray.300' }}
          css={{
            '&+.chakra-select__icon-wrapper': {
              width: '50px',
              height: '50px',
              borderTopRightRadius: '20px',
              borderBottomRightRadius: '20px',
              background: theme.colors.alea[500],
              right: '0',
            },
            '&+.chakra-select__icon-wrapper .chakra-select__icon': {
              fontSize: '24px',
              color: 'white !important',
            },
          }}
          bg="white"
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </Flex>
      {error && (
        <Box color="red.500" mt="2">
          {error}
        </Box>
      )}
    </FormControl>
  );
};

export default AleaDropdown;
